<template>
  <v-menu
    v-model="isOpen"
    bottom
    transition="scale-transition"
    :close-on-content-click="false"
    :nudge-top="-10"
    offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-img
        v-bind="attrs"
        v-on="on"
        class="mx-2 cursor-pointer"
        width="35"
        height="35"
        src="@Assets/images/color_picker.png"></v-img>
      <!-- <v-btn dark v-bind="attrs" v-on="on"> Menu as Popover </v-btn> -->
    </template>
    <v-color-picker v-model="color"></v-color-picker>
  </v-menu>
</template>

<script>
  export default {
    name: 'ColorPicker',
    props: {
      value: {
        type: String,
        default: () => null,
      },
    },
    data() {
      return {
        isOpen: false,
        color: this.value,
      };
    },
    watch: {
      color(newColor) {
        this.$emit('input', newColor);
      },
    },
  };
</script>

<style scoped></style>
